<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="main-content w-100 px-4 py-3">
        <div class="main-heading mb-4">
            <h1>Excel Dump Dashboard</h1>
        </div>

        <ul class="nav nav-tabs custom-tabs mb-4">
            <li class="nav-item custom-tab-item">
                <a class="nav-link custom-tab-link" [class.active]="selectedTab === 'product'"
                    (click)="switchTab('product')">
                    Product Dump
                </a>
            </li>
            <li class="nav-item custom-tab-item">
                <a class="nav-link custom-tab-link" [class.active]="selectedTab === 'costing'"
                    (click)="switchTab('costing')">
                    Costing Dump
                </a>
            </li>
        </ul>

        <div *ngIf="selectedTab === 'product'" class="dump-section">
            <h4 class="section-title">Fields-wise Dump</h4>
            <div *ngIf="keys?.length > 0; else noData">
                <div class="d-flex flex-wrap gap-3 mb-4 align-items-end section-fields">

                    <div class="field-wrapper flex-grow-1">
                        <label class="field-label">Select Fields</label>
                        <p-multiSelect [options]="formattedKeys" [(ngModel)]="selectedKeys" optionLabel="label"
                            optionValue="value" placeholder="Select Fields" [filter]="true" [showClear]="true"
                            selectedItemsLabel="{0} fields selected" [maxSelectedLabels]="3" class="w-100" required />
                    </div>

                    <div class="field-wrapper flex-grow-1">
                        <label class="field-label">Select ROA</label>
                        <p-dropdown [options]="ROADropdownOptions" [(ngModel)]="selectedROA" placeholder="Select ROA"
                            optionLabel="label" optionValue="value" class="w-100"></p-dropdown>
                    </div>

                    <div class="field-wrapper flex-grow-1">
                        <label class="field-label">Select Status</label>
                        <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" placeholder="Select Status"
                            optionLabel="label" optionValue="value" class="w-100"></p-dropdown>
                    </div>

                    <div class="field-wrapper flex-grow-1">
                        <label class="field-label">Select Dump Mode</label>
                        <p-dropdown [options]="dumpModeOptions" [(ngModel)]="dumpMode" placeholder="Select Dump Mode"
                            class="w-100"></p-dropdown>
                    </div>

                    <div class="field-wrapper text-end d-flex flex-column align-items-start">
                        <button pButton type="button" label="Get Dump" icon="pi pi-download" (click)="openDialog()"
                            class="p-button-primary" [disabled]="isLoadingDump">
                        </button>

                        <div *ngIf="isLoadingDump"
                            class="full-page-loader d-flex justify-content-center align-items-center">
                            <div class="text-center">
                                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                                <p class="mt-2 mb-0 fw-medium">Your dump is being processed...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noData>
                <p>No keys found.</p>
            </ng-template>
        </div>

        <div *ngIf="selectedTab === 'costing'" class="costing-tab py-4">
            <h4 class="mb-4">Costing Dump Options</h4>

            <div class="d-flex flex-wrap justify-content-start">
                <button pButton type="button" label="Get API Costing Dump" icon="pi pi-download"
                    class="p-button-primary mr-4 mb-2" (click)="openDialog('api')"></button>

                <button pButton type="button" label="Get BE Costing Dump" icon="pi pi-download"
                    class="p-button-success mr-4 mb-2" (click)="openDialog('be')"></button>

                <button pButton type="button" label="Get RLD Costing Dump" icon="pi pi-download"
                    class="p-button-warning mb-2" (click)="openDialog('rld')"></button>
            </div>
            <div *ngIf="isLoadingDump" class="full-page-loader d-flex justify-content-center align-items-center">
                <div class="text-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <p class="mt-2 mb-0 fw-medium">Your dump is being processed...</p>
                </div>
            </div>
        </div>

    </div>
</div>

<p-dialog header="Enter Excel Name" [(visible)]="dialogVisible" [modal]="true" [style]="{ width: '30vw' }"
    [closable]="false">
    <div class="p-fluid" style="padding: 10px;">
        <div class="field mb-4">
            <label for="excelName" class="font-medium d-block mb-2">
                What name would you like to give to your Excel?
            </label>
            <input id="excelName" type="text" pInputText [(ngModel)]="excelName" placeholder="e.g. live_products_dump"
                class="w-100" />
        </div>
        <div class="d-flex justify-content-end gap-3">
            <button pButton label="Cancel" class="p-button-secondary mr-4" (click)="dialogVisible = false"></button>
            <button pButton label="Save" icon="pi pi-save" (click)="saveDump()" [disabled]="!excelName"></button>
        </div>
    </div>
</p-dialog>